import {useEffect, useState} from 'react';

import {useParams} from 'react-router-dom';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useContact} from '../hooks/useContact';
import {useContactsSelection} from '../hooks/useContactsSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {Grid, Paper, Text} from '@mantine/core';
import {FormDrawer} from '../drawers/FormDrawer';

export const EditPage = () => {

    const {id: componentId} = useParams();
    const [drawerOpened, setDrawerOpened] = useState(false);

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        fetchRecord,
        updateRecord,
    } = useContact(componentId);

    const {handleClearSelection} = useContactsSelection();

    const {
        mode,
        tools,
        handleSetMode,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [componentId]);

    useEffect(() => {
        if (mode === 'edit') {
            setDrawerOpened(true);
            handleSetMode('view');
        }
    }, [mode]);

    if (!component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.firstName && component.lastName ? `${component.firstName} ${component.lastName}` : component.email || component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >
            <Grid>
                <Grid.Col span={{
                    base: 4,
                    sm: 12
                }}>
                    <Profile record={component}/>
                </Grid.Col>
                <Grid.Col span={{
                    base: 8,
                    sm: 12
                }}>
                    <Paper p="md" withBorder>
                        <Text size="lg" fw={500}>{component.company || 'No company specified'}</Text>
                    </Paper>
                </Grid.Col>
            </Grid>

            <FormDrawer
                record={component}
                handleSubmit={updateRecord}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </FormPageLayout>
    );
};
